<p-toast position="top-right"></p-toast>

<div class="m2-container-default">
<form [formGroup]="partnerDetailsForm">
    <p-scrollPanel [style]="{height: 'calc(80vh)'}">
        <div class="mco-header mt-4">
            <div class="mco-header__title mb-4">Your Personal Information</div>
            <div class="mco-subheader">Review and update your personal information to ensure accuracy</div>
        </div>
        <div *ngIf="loading" style="text-align: center; padding: 30px;">
            <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                               fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
        </div>

        <div *ngIf="!loading" class="merchant-form-body">
            <div class="flex flex-row">
                <mat-form-field appearance="fill" class="mt-3">
                    <mat-label>Company Position</mat-label>
                    <mat-select formControlName="CompanyPosition">
                      <mat-option *ngFor="let companyPosition of companyPositions" [value]="companyPosition.value">{{companyPosition.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <mat-form-field appearance="fill">
                        <mat-label>Salutation</mat-label>
                        <mat-select formControlName="Salutation">
                            <mat-option *ngFor="let salutation of salutations" [value]="salutation.value">{{salutation.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="merchant-column merchant-column-50">
                    <mat-form-field appearance="fill">
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="FirstName" placeholder="First Name">
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['FirstName'].invalid && (partnerDetailsForm.controls['FirstName'].touched || partnerDetailsForm.controls['FirstName'].dirty)">
                            First name is required.
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <mat-form-field appearance="fill">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="LastName" placeholder="Last Name">
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['LastName'].invalid && (partnerDetailsForm.controls['LastName'].touched || partnerDetailsForm.controls['LastName'].dirty)">
                            Last name is required.
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div class="merchant-column merchant-column-50">
                    <mat-form-field appearance="fill">
                        <mat-label>Suffix</mat-label>
                        <mat-select formControlName="Suffix">
                            <mat-option [value]=""></mat-option>
                            <mat-option *ngFor="let suffix of suffixes" [value]="suffix.value">{{suffix.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="merchant-label">Home Address</div>
            <div class="flex flex-row">
                <mat-form-field appearance="fill">
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="Address" placeholder="Address" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let address of addresses" [value]="address">
                          {{address}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['Address'].invalid && (partnerDetailsForm.controls['Address'].touched || partnerDetailsForm.controls['Address'].dirty)">
                        Address is required.
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <mat-form-field appearance="fill">
                        <mat-label>City</mat-label>
                        <input matInput formControlName="City" placeholder="City">
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['City'].invalid && (partnerDetailsForm.controls['City'].touched || partnerDetailsForm.controls['City'].dirty)">
                            City is required.
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div class="merchant-column merchant-column-50">
                    <mat-form-field appearance="fill">
                        <mat-label>Zip Code</mat-label>
                        <input matInput formControlName="PostalCode" placeholder="Zip Code">
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['PostalCode'].errors?.['required']">
                            Zip Code is required.
                        </mat-hint>
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['PostalCode'].errors?.['pattern']">
                            Zip Code is invalid.
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="flex flex-row">
                <div class="merchant-column merchant-column-46">
                    <mat-form-field appearance="fill">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="Birthday">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['Birthday'].invalid && (partnerDetailsForm.controls['Birthday'].touched || partnerDetailsForm.controls['Birthday'].dirty)">
                            Date of Birth is required.
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div class="merchant-column merchant-column-50">
                    <mat-form-field appearance="fill">
                        <mat-label>Nationality</mat-label>
                        <mat-select formControlName="NationalityId">
                            <mat-option *ngFor="let nationality of nationalities" [value]="nationality.Id">{{nationality.Name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <mat-form-field appearance="fill">
                        <mat-label>Cellphone Number</mat-label>
                        <input matInput formControlName="Phone" placeholder="Cellphone Number" maxlength="13">
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['Phone'].errors?.['required']">
                            Phone is required.
                        </mat-hint>
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['Phone'].errors?.['pattern']">
                            Phone is invalid.
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div class="merchant-column merchant-column-50">
                    <mat-form-field appearance="fill">
                        <mat-label>Company Email</mat-label>
                        <input type="email" matInput formControlName="Email" placeholder="Email">
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['Email'].errors?.['required']">
                            Email is required.
                        </mat-hint>
                        <mat-hint class="error-message" *ngIf="partnerDetailsForm.controls['Email'].errors?.['email']">
                            Email is invalid.
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="merchant-form">
                <div class="flex flex-row merchant-label-box mb-3">
                    <img class="onboarding-img" src="/XpressApp/assets/images/partner/onboarding/info-onboarding.png">
                    Please review the information on the above to make sure the details are correct
                </div>
                <div class="flex flex-row float-right pb-5">
                    <div>
                        <button *ngIf="!isEditable" mat-button (click)="enableFields()" class="edit-btn">Edit</button>
                        <button *ngIf="isEditable" mat-button (click)="disableFields()" class="edit-btn" color="warn">Cancel</button>
                    </div>
                    <div style="margin-left: 24px;">
                        <button *ngIf="isEditable" [ngClass]="{'btn-disabled': partnerDetailsForm.invalid || !partnerDetailsForm.dirty }" [disabled]="partnerDetailsForm.invalid || !partnerDetailsForm.dirty" mat-button class="submit-btn" color="primary" (click)="confirm()">Confirm</button>
                        <button *ngIf="!isEditable && merchant.MerchantStatus === merchantStatusEnum.ApprovedCompanyDetail" mat-button class="submit-btn" color="primary" (click)="onConfirmMerchant()">The details are correct</button>
                    </div>
                </div>
            </div>
        </div>

    </p-scrollPanel>
</form>
</div>